<template>
  <vx-card title="Documents" no-shadow>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="Document Template Marge Fields" forceRender>
        <div class="pl-10 pt-5">
          <p class="font-medium w-1/2 text-justify">
            The following fields are available for use in a Document Template. Selecting a
            matter will preview fields tailored for that matter.
          </p>
          <h4 class="font-semibold">
            Select A Matter
          </h4>
          <a-form-item>
            <input placeholder="Confirm New password" class="ant-input w-1/2" />
          </a-form-item>
        </div>
        <XTable :model="model" v-if="false"></XTable>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Document Sources">
        <div class="pl-10 pt-5">
          <h4 class="font-semibold">
            Default Document Source
          </h4>
          <p class="font-medium w-1/2 text-justify">
            Choose which documents you want to be shown by default in Clio. At any time
            documents from other sources can be viewed by clicking the "Clio" tab on the
            Documents page.
          </p>
          <a-form-item>
            <input placeholder="My document" class="ant-input w-1/2" />
          </a-form-item>
          <div class="flex items-center mt-5">
            <a-button type="primary" size="large" style="border-radius: 3px !important;">
              Update Default Document Source
            </a-button>
            <div class="pl-2">or</div>
            <a-button type="link">
              Cancel
            </a-button>
          </div>
        </div>
        <a-divider/>
         <div class="pl-10">
           <h4>Default Document Source</h4>
           <p class="font-medium w-1/2 text-justify">
             Clio can integrate with a number of third party document sources. Clio will
             automatically create folders for your clients and matters. Once connected,
             documents added to these folders will automatically show in Clio. Documents can
             also be uploaded through Clio
           </p>
         </div>
      </a-tab-pane>
      <a-tab-pane key="3" tab="Document Preview">
        <div class="pl-10 pt-5">
          <h4 class="font-semibold">
            Default Document Source
          </h4>
          <p class="font-medium w-1/2 text-justify">
            lexi uses Box View to allow you to easily preview documents with supported
            extensions such as: .pdf, .doc, .docx, .ppt, .pptx.
          </p>
          <p class="font-medium w-1/2 text-justify">
            Once you enable Box View, you are giving permission for Clio to temporarily
            store a copy of any previewed document on Box’s secure, U.S.-based servers.
          </p>
          <p class="font-medium w-1/2 text-justify">
            To , please read Box’s Terms of Service prior to enabling the Document
            Preview setting in Clio.
          </p>
          <a-form-item>
            <a-checkbox>
              <small>Enable Box View</small>
            </a-checkbox>
          </a-form-item>
        </div>
        <a-divider/>
        <div class="flex pl-10 items-center">
          <a-button type="primary" size="large" style="border-radius: 3px !important;">
            Update Default Document Source
          </a-button>
          <div class="pl-2">or</div>
          <a-button type="link">
            Cancel
          </a-button>
        </div>
      </a-tab-pane>
    </a-tabs>
  </vx-card>

</template>

<script>
    import * as TableColMerge from "./documentMergeTbl";
    import XTable from "../../../../components/x-table/XTable";
    export default {
        name: "Documents",
        components:{
          XTable
        },
        data(){
          return{
            model:null
          }
        },
        created() {
          this.model = TableColMerge.default
        }
    }
</script>

<style scoped>

</style>
